import Link from 'next/link';
import { policies } from '@/lib/data';

export default function LegalLinks() {
  return (
    <div className="flex flex-col text-ctext-light lg:col-span-3 col-span-12 lg:items-start items-center lg:pt-0 pt-12">
      <p className="font-bold pb-2 text-2xl">
        Informative
      </p>
      <Link
        href={policies.privacy}
        className="hover:underline underline-offset-4 text-secondary-light/90 py-1 rounded-md font-medium transition-colors">
        Privacy Policy
      </Link>
      <Link
        href={policies.cookies}
        className="hover:underline underline-offset-4 text-secondary-light/90 py-1 rounded-md font-medium transition-colors">
        Cookies
      </Link>
    </div>
  );
}
